<template>
  <div class="authenticated">
    <navigation></navigation>
    <div class="container">
      <div class="application-content">
        <alert v-if="isError" type="danger"/>
        <alert v-if="isMessage" type="primary"/>
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import Alert from '@/components/Alert'
  import Nav from '@/components/Nav'

  export default {
    name: 'MainAdmin',
    data () {
      return {}
    },
    computed: {
      ...mapGetters(['isError', 'isMessage']),
      ...mapState('user', ['isAdmin'])
    },
    components: {
      alert: Alert,
      navigation: Nav
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/MainAdmin.vue